export default __webpack_public_path__ + "static/8_32-e72432092e25885390341ef0f3752631.png";